<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 会员记录
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="关键字" prop="keywords">
                <el-input v-model="searchform.keywords" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="searchform.datelist"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                   :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['supervise_select']"
              >搜索</el-button>
              <!-- <el-button
              v-permission="['supervise_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>-->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{title}}</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="openid" label="OpenID" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="终端名称" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="终端手机" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="registerTime" label="推荐时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="provinceName" label="省" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityName" label="市" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="areaName" label="区" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="注册地点" min-width="180" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { searchreferences } from "@/api/market/viprecord";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      title: "推荐人流水",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      searchform: {
        beginTime: null,
        endTime: null,
        keywords: null,
        datelist: [],
        userType: 3,
        currPage: 1,
        pageSize: 10
      },
      value: true
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      searchreferences(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {}
    },
    //搜索事件
    search() {
      this.currentPage = 1;
      this.Tabledata({
        keywords: this.searchform.keywords,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        page: 1,
        rows: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        keywords: this.searchform.keywords,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        rows: this.searchform.pageSize,
        page: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        ifScanSuccess: this.searchform.ifScanSuccess,
        qrcode: this.searchform.qrcode,
        batchno: this.searchform.batchno,
        dealer_name: this.searchform.dealer_name,
        screateTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        ecreateTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      };
      check(obj).then(response => {
        this.packdate(response.data.list);
        this.tableDataDownload = response.data.list;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "稽查人姓名",
            "稽查人编码",
            "查询日期",
            "查询地点",
            "查询次数",
            "查询方式",
            "产品名称",
            "批次号",
            "防伪码",
            "出库日期",
            "运单号",
            "送达方名称",
            "送达方地址",
            "查询结果"
          ];
          const filterVal = [
            "employee_name",
            "account_name",
            "create_time",
            "address",
            "qrcodeqty",
            "query_method",
            "product_name",
            "batchno",
            "qrcode",
            "freight_bill_code_time",
            "freight_bill_code",
            "dealer_name",
            "addr",
            "ifflee_good"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>